import styled from 'styled-components';

export const CreditLimitWarningContainer = styled.div`
  display: flex;
  padding: var(--spacing-m) var(--spacing-l);
  justify-content: center;
  align-items: center;
  background: var(--color-interface-secondary-normal);
  gap: var(--spacing-l);

  > p,
  > svg {
    color: var(--color-interface-neutral-light);
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  background: var(--color-interface-neutral-light);
  gap: calc(var(--spacing-xxs) * 2);
  padding: calc(var(--spacing-xxs) * 2);
  border-radius: var(--radius-100);
`;
